module.exports = __webpack_public_path__ + "img/bitybeta.f31a3310.png";